module.exports = __webpack_public_path__ + "img/kyara_popup2.08d10f0b.png";